import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as common from '../common'

import type { App } from './app'

// NOTE: this makes creating a TypeChecker easier
type PageBase = common.Identified<Page.Id> &
  common.Named &
  common.Described.Optionally
/**
 * Represents a page that can be added to an {@link App}
 *
 * __NOTE:__ this page is not necessarily associated with any particular
 * {@link App}. An {@link App.Page} represents an actual {@link Page} within an
 * {@link App}
 */
export interface Page extends PageBase {}
export namespace Page {
  /**
   * Identifies a {@link Page}
   */
  export type Id = string
  export namespace Id {
    export const isId: TypeChecker<Id> =
      TypeChecker.isString.usingAlias('Page.Id')
    export const assertIsId: TypeAsserter<Id> = TypeAsserter.Factory.from(isId)
  }
}
